import { Injectable, inject } from '@angular/core';
import {
  DocumentManagementApi,
  type SoftDeletedListResponse,
} from '@tourfold/libraries/tf-api-client-public-v2';

/**
 * Thin wrapper over the tenant-wide soft-deleted listing (the user's Trash). Same shape as
 * `StarsService.listAll` — fetches a flat list of soft-deleted documents sorted by
 * `soft_deleted_at` desc — but tenant-wide rather than per-user (today; per-folder permissions
 * will scope this in a later phase).
 *
 * Used by the "Trash" smart entry in the folder browser. Folders are never soft-deleted under
 * the new model so the response is documents-only.
 */
@Injectable({ providedIn: 'root' })
export class TrashService {
  private readonly api = inject(DocumentManagementApi);

  listAll(): Promise<SoftDeletedListResponse> {
    return this.api.listSoftDeleted({});
  }
}
